import React from 'react'
import logo from '../logo.svg';

function Header() {
  return (
    <header className="App-header">
      <img className="App-logo" src={logo} alt="logo"/>
      <h1>My Type Racer</h1>
    </header>
  )
}

export default Header;